import type React from 'react';
import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import type { RootState } from '../../app/store';
import { setProgressStep } from '../../redux/progress-bar/progressBar';
import { getPayment } from '../../redux/payment/payment';
import { setPupilDetails, YesNoOptions } from '../../redux/user-selection/userSelection';
import type { PupilFormValues } from '../../components/customer-details-form/CustomerDetailsForm';
import CustomerDetailsForm from '../../components/customer-details-form/CustomerDetailsForm';
import { ProvisionalBookingInfo } from '../../components/provisional-bookinginfo/ProvisionalBookingInfo';
import { useNavigate } from 'react-router-dom';
import './PupilDetails.css';

export enum PupilFormType {
    Pupil = 1,
    ThirdParty = 2,
}

const PupilDetails: React.FC = () => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    const lessonTime = useAppSelector((state: RootState) => state.userSelection.lessonTime);

    // Equivalent to componentDidMount
    useEffect(() => {
        dispatch(setProgressStep({ step: 3 }));

        const appEventData = 'AppEventData';
        (window as unknown as { [key: string]: Array<{ event: string; page: { pageName: string; channel: string } }> })[appEventData].push({
            event: 'stepLoaded',
            page: {
                pageName: 'ie:secure:my-aviva:driving-school:pupil-details',
                channel: 'secure',
            },
        });
    }, [dispatch]);

    const onSubmit = (values: PupilFormValues) => {
        if (
            values.purchaser === PupilFormType.ThirdParty ||
            (values.thirdParty && values.sameDetails === YesNoOptions.No)
        ) {
            values.pupil.marketingConsent = false;
        } else {
            delete values.thirdParty;
        }

        dispatch(setPupilDetails({ pupilDetails: values }));
        navigate('/payment');
        return dispatch(getPayment());
    };

    return (
        <div className="details-form-container" data-testid="pupil-details">
            <h1 className="text__center">Booking Details</h1>
            {lessonTime && <ProvisionalBookingInfo userSelection={lessonTime} />}
            <CustomerDetailsForm onSubmit={onSubmit} />
        </div>
    );
};

export default PupilDetails;